module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// ./~/_readable-stream@2.3.8@readable-stream/duplex-browser.js
// module id = 767
// module chunks = 0